import React, { useContext, useState, useEffect } from 'react'
import { NavLink } from 'react-router-dom'
import { useWindowSize } from 'usehooks-ts'
import { UserContext } from '../../context/UserProvider'

const Navbar = () => {

  const [ open, setOpen ] = useState(false)
  const [ mobile, setMobile ] = useState(true)
  const { width } = useWindowSize()
  const { logoutUser } = useContext(UserContext)
  
  useEffect(() => {
    if (width > 992) {
      setMobile(false)
      setOpen(true)
    } else {
      setMobile(true)
    }
  }, [width])

  const logout = () => {
    logoutUser()
  }

  return (
    <nav className='nav flex justify-between items-center px-4 lg:px-8 border-b border-solid border-gray-100 max-w-7xl mx-auto'>
      <div className='nav__logo'>
        <NavLink to={'/'}>
          <img
            src='../images/logo-ruda.jpeg'
            className='mx-auto h-12 cursor-pointer'
            alt='Isologo Ruda'/>
        </NavLink>
      </div>
      <div className='nav__menu'>
        {
          open ? (
            <>
              <ul className='absolute w-full top-0 left-0 bg-white pt-5 mt-16 z-30 lg:relative lg:w-auto lg:pt-0 lg:mt-0 lg:flex'>
                <NavLink to="/orders" activeclassname="active">
                  <li className='cursor-pointer py-3 px-5 border-b border-solid border-slate-200 hover:bg-indigo-50 lg:py-5 lg:border-b-transparent'>Pedidos</li>
                </NavLink>
                <NavLink to="/products" activeclassname="active">
                  <li className='cursor-pointer py-3 px-5 border-b border-solid border-slate-200 hover:bg-indigo-50 lg:py-5 lg:border-b-transparent'>
                    Productos
                  </li>
                </NavLink>
                <NavLink to="/account" activeclassname="active">
                  <li className='cursor-pointer py-3 px-5 border-b border-solid border-slate-200 hover:bg-indigo-50 lg:py-5 lg:border-b-transparent'>Cuenta</li>
                </NavLink>
                <li className='cursor-pointer py-3 px-5 border-b border-solid border-slate-200 hover:bg-indigo-50 lg:py-5 lg:border-b-transparent' onClick={() => logout()}>Cerrar Sesión</li>
              </ul>
              { 
                mobile && <svg className="h-6 w-6" stroke="currentColor" fill="none" viewBox="0 0 24 24" onClick={() => setOpen(false)}>
                  <path className="inline-flex" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12"></path>
                </svg>
              }
            </>
          ) : (
            mobile && <svg className="h-6 w-6" stroke="currentColor" fill="none" viewBox="0 0 24 24" onClick={() => setOpen(true)}>
            <path className="inline-flex" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 6h16M4 12h16M4 18h16"></path>
          </svg>
          )
        }
      </div>
    </nav>
  )
}

export default Navbar